import { Button, Stack, Text } from '@chakra-ui/react'

import ModalV3 from '@/components/UI/Modal/ModalV3'

import { ContactInfoAlert } from './ContactInfoAlert'
import { REVIEW_BUSINESS_DAYS } from './constants'

export function ExternalPlatformModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}): JSX.Element {
  return (
    <ModalV3
      title="Verification from External Platform"
      size="2xl"
      open={isOpen}
      onClose={onClose}
      body={() => (
        <Stack spacing="16px">
          <Text>
            If you need your hours verified through an external platform, you don&apos;t need to
            submit anything to Schoolhouse directly.
          </Text>
          <Text>
            When creating your verification request on the external platform, please include a link
            to your Schoolhouse profile in the notes and/or description. We will use this
            information to validate your hours.
          </Text>
          <Text>
            If you do not include your Schoolhouse profile link, your external hours verification
            request will be rejected.
          </Text>
          <Text fontWeight="bold">
            Please allow up to {REVIEW_BUSINESS_DAYS} business days for us to review external
            verification requests.
          </Text>
          <ContactInfoAlert />
        </Stack>
      )}
      rightFooterContent={() => (
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      )}
    />
  )
}
